export const FRAUDULENT_PAYMENT_INTENT = {
    clientSecret: "005f8890-f086-4488-83b6-0d73c4b24c2a",
    paymentIntentId: "pi_000NZdc827bceH52h72",
};
